// extracted by mini-css-extract-plugin
module.exports = {"ScriptModule_heading":"ScriptModule_ScriptModule_heading__bYNdw"};